import React, { createContext } from 'react';
import {
  IChildrenProp,
  ILoadingProp,
} from 'types/components/components.interface';
import './InfoBox.scss';
import InfoBoxItems from './modules/items/InfoBoxItems';
import InfoBoxItem from './modules/item/InfoBoxItem';
import InfoBoxImage from './modules/image/InfoBoxImage';

interface IInfoBoxProps extends IChildrenProp, ILoadingProp {}

export const InfoBoxContext = createContext<ILoadingProp>({ loading: false });

const InfoBox = ({ children, loading }: IInfoBoxProps) => {
  return (
    <InfoBoxContext.Provider value={{ loading: loading }}>
      <div className='info-box'>{children}</div>
    </InfoBoxContext.Provider>
  );
};

InfoBox.Items = InfoBoxItems;
InfoBox.Item = InfoBoxItem;
InfoBox.Image = InfoBoxImage;

export default InfoBox;
